import { render, staticRenderFns } from "./CrowdfundingRewardCardList.vue?vue&type=template&id=90f0ca20"
import script from "./CrowdfundingRewardCardList.vue?vue&type=script&lang=js"
export * from "./CrowdfundingRewardCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports